import {
  LayoutDashboard, HelpCircle, CalendarDays, BellRing, HeartHandshake, BedDouble,
  QrCode, BarChart3, Activity, Building2, Receipt, UsersRound, Settings, ClipboardList, Truck, BadgeCheck,} from "lucide-react";
import { useEffect, useState } from "react";
import LuxSidebar from "./LuxSidebar";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// `managerOnly` mirrors the backend gate — /hotel-admin/* rejects hotel_staff,
// so front-desk users never see a link that would 403 on them.
const NAV = [
  { section: "Overview",   to: "/hotel/dashboard",           label: "Dashboard",           icon: LayoutDashboard, tid: "hotel-nav-dashboard" },
  { section: "Front desk", to: "/hotel/guest-assistance",    label: "Guest Assistance",    icon: HelpCircle,      tid: "hotel-nav-assistance" },
  { section: "Front desk", to: "/hotel/appointments",        label: "Appointments",        icon: CalendarDays,    tid: "hotel-nav-appointments" },
  { section: "Front desk", to: "/hotel/folio-approvals",     label: "Room Charges",        icon: BellRing,        tid: "hotel-nav-folio-approvals" },
  { section: "Front desk", to: "/hotel/service-recovery",    label: "Service Recovery",    icon: HeartHandshake,  tid: "hotel-nav-service-recovery" },
  { section: "Front desk", to: "/hotel/arrivals",            label: "Inbound Arrivals",    icon: Truck,           tid: "hotel-nav-arrivals" },
  { section: "Front desk", to: "/hotel/handover",            label: "Shift Handover",      icon: ClipboardList,   tid: "hotel-nav-handover" },
  { section: "Property",   to: "/hotel/rooms",               label: "Rooms",               icon: BedDouble,       tid: "hotel-nav-rooms" },
  { section: "Property",   to: "/hotel/qr",                  label: "QR Codes",            icon: QrCode,          tid: "hotel-nav-qr" },
  { section: "Property",   to: "/hotel/qr-analytics",        label: "QR Analytics",        icon: BarChart3,       tid: "hotel-nav-qr-analytics" },
  { section: "Property",   to: "/hotel/service-utilization", label: "Service Utilization", icon: Activity,        tid: "hotel-nav-utilization" },
  { section: "Business",   to: "/hotel/statement",           label: "Monthly Statement",   icon: Receipt,         tid: "hotel-nav-statement", managerOnly: true },
  { section: "Business",   to: "/hotel/billing",             label: "Corporate Billing",   icon: Building2,       tid: "hotel-nav-billing" },
  { section: "Business",   to: "/hotel/folios",              label: "Guest Folios",        icon: Receipt,         tid: "hotel-nav-folios" },
  { section: "Business",   to: "/hotel/charge-exemptions",   label: "Charge Exemptions",   icon: BadgeCheck,      tid: "hotel-nav-charge-exemptions", managerOnly: true },
  { section: "Business",   to: "/hotel/staff",               label: "Staff",               icon: UsersRound,      tid: "hotel-nav-staff", managerOnly: true },
  { section: "Business",   to: "/hotel/settings",            label: "Settings",            icon: Settings,        tid: "hotel-nav-settings" },
];

export default function HotelNav() {
  const { user } = useAuth();
  const [handoverCount, setHandoverCount] = useState(0);
  const isManager = user?.role === "hotel_manager";

  useEffect(() => {
    const load = () => api.get("/hotel/shift-handover/unread")
      .then((r) => setHandoverCount(r.data?.count || 0))
      .catch(() => setHandoverCount(0));
    load();
    window.addEventListener("aura:handover-changed", load);
    return () => window.removeEventListener("aura:handover-changed", load);
  }, []);

  const items = NAV
    .filter((n) => !n.managerOnly || isManager)
    .map((n) => (n.to === "/hotel/handover" ? { ...n, badge: handoverCount } : n));
  return <LuxSidebar items={items}
    subtitle={isManager ? "Property Console" : "Concierge Console"}
    footer="Non-clinical operations only"
    testidPrefix="hotel-nav" homePath="/hotel/dashboard" />;
}
